import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AlertController, LoadingController, MenuController, ModalController } from '@ionic/angular';

import { GlobalConstants } from 'src/app/services/globalConstants/global-constants.service';
import { GlobalFunctionsService } from 'src/app/services/globalFunctions/global-functions.service';
import { StorageService } from 'src/app/services/storage/storage.service';

import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { VisitaService } from 'src/app/services/visita/visita.service';
import { PedidoDetalleClientePage } from '../pedidoDetalleCliente/pedidoDetalleCliente.page';

@Component({
  selector: 'app-account',
  templateUrl: './account.page.html',
  styleUrls: ['./account.page.scss'],
})
export class AccountPage implements OnInit {

  //#region Propiedades

  public _appVersion: string;

  public _utmCampaign: string = null;
  public _utmContent: string = null;
  public _utmMedium: string = null;
  public _utmSource: string = null;
  public _utmTerm: string = null;

  public _validando: boolean = false;
  public _option: number = 1;
  public _listPedidos: any;

  //#endregion Propiedades

  //#region Constructor

  constructor(private _route: ActivatedRoute,
              private _menuCtrl: MenuController,
              private _usuarioSrv: UsuarioService,
              private _visitaSrv: VisitaService,
              public storage: StorageService,
              private _router: Router,
              public alertController: AlertController,
              public _userSrv: UsuarioService,
              public _globalSrv: GlobalFunctionsService,
              private modalCtrl: ModalController,
              public _loadingCtrl: LoadingController,
              ) {
                this._listPedidos = [];
                console.log('AccountPage >> constructor');

  }

  //#endregion Constructor

  //#region Eventos NG

  public ngOnInit() {
    console.log('AccountPage >> ngOnInit');
    this._menuCtrl.enable(false);
  }

  public async ionViewDidEnter() {
    console.log('AccountPage >> ionViewDidEnter');

    this._appVersion = GlobalConstants.APP_VERSION;

    // recupera/crea/guarda token publico
    await this._usuarioSrv.doPublicToken();

    // registra visita
    await this._route.queryParams.subscribe((params) => {

      // recupera datos de UTM
      if (params['utm_campaign'] !== undefined) { this._utmCampaign = params['utm_campaign']; }
      if (params['utm_content'] !== undefined) { this._utmContent = params['utm_content']; }
      if (params['utm_medium'] !== undefined) { this._utmMedium = params['utm_medium']; }
      if (params['utm_source'] !== undefined) { this._utmSource = params['utm_source']; }
      if (params['utm_term'] !== undefined) { this._utmTerm = params['utm_term']; }

      this._visitaSrv.guardar('Login', null, null,
      null, null, null, null,
      null, null,
      this._utmCampaign, this._utmContent, this._utmMedium, this._utmSource, this._utmTerm).subscribe();
    });
    this.getPedidos();
  }

  //#endregion Eventos NG

  //#region Eventos Botones

  public async closeSession(){
    const alert = await this.alertController.create({
      header: 'Cerrar sesión',
      // subHeader: 'Subtitle',
      message: '¿Realmente desea cerrar su sesión?',
      buttons: [
        {
          text: 'Cancelar',
          handler: data => {

          }
        },
        {
          text: 'Cerrar',
          handler: data => {
            this.endSesion();
          }
        }
      ]
    });

    await alert.present();
  }

  public async endSesion() {
    this.storage.removeSesion()
                      .then(() => {
      this._router.navigate(['/login']);
    });
  }

    //#endregion

  //#region Otros Métodos

  public async getPedidos(){
    this._listPedidos = [];
    
    this._loadingCtrl.create({ // crea 'wait' como promise
      spinner: 'crescent',
      cssClass: 'loading',
      message: 'Espere...',
    }).then((loading) => {
      loading.present();

      this._userSrv.getPedidos().subscribe(() => {
        
        console.log('lista de ventas');
        console.log(this._userSrv.AllPedidos);
        this._listPedidos = this._userSrv.AllPedidos;
        loading.dismiss();
      });
    });

  }

  public async detailPedido(item){
    const modal = await this.modalCtrl.create({
      component: PedidoDetalleClientePage,
      cssClass: 'modalPedido',
      componentProps: {
        '_productos': item['Productos'],
        '_pedido': item
      }
    });
    modal.present();
  }

    public optionView(num){
      this._option = num;
    }
  //#endregion
}
